export const formatNumber = (value: string | number) => {
    let tempData: number = 0;
    if(typeof value === 'string'){
        tempData = parseInt(value);
    }
    return tempData.toLocaleString();
}